import { mediaProgrammingReducers } from './quickstart-media.service';

export const QUICKSTART_MEDIA_REDUCERS = {
  mediaProgramming: mediaProgrammingReducers
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-media/quickstart-media.store.ts